// extracted by mini-css-extract-plugin
export default {"main":"Requests_main__u0xZQ","button":"Requests_button__A13g0"};